import { TCodelistName } from "./types";

type TCodelistTranslationMap = {
  [K in TCodelistName]?: string;
};

const CODELIST_TRANSLATION_MAP: TCodelistTranslationMap = {
  availability: "AVAILABILITY",
  "company-size": "COMPANY_SIZE",
  "consultant-profile-status": "CONSULTANT_PROFILE_STATUS",
  "country-codes": "COUNTRY_CODES",
  "dates-formats": "DATES_FORMATS",
  "filter-email-frequency": "FILTER_EMAIL_FREQUENCIES",
  "job-request-application-statuses": "JOB_REQUEST_APPLICATION_STATUSES",
  "job-request-statuses": "JOB_REQUEST_STATUSES",
  "language-levels": "LANGUAGE_LEVELS",
  "assignments-statuses": "ASSIGNMENTS_STATUSES",
  languages: "LANGUAGES",
  "lifecycle-action-performed": "LIFECYCLE_ACTION_PERFORMED",
  "numbers-formats": "NUMBERS_FORMATS",
  "remote-work": "REMOTE_WORK",
  "skill-role-levels": "SKILL_ROLE_LEVELS",
  "task-priorities": "TASK_PRIORITY",
  "task-types": "TASK_TYPE",
  "times-formats": "TIMES_FORMATS",
  "work-preference": "WORK_PREFERENCE",
};

export const getTranslationKey = (codelistName: TCodelistName, code: string) => {
  const translationMapKey = CODELIST_TRANSLATION_MAP[codelistName];
  return translationMapKey ? `CODELISTS.${translationMapKey}.${code}` : null;
};
